import React from 'react'
import { paginator } from './paginator-utils'

export interface PaginatorProps {
    current: number
    total: number
    maxElements?: number
    onClick: (page: number) => void
}

export default function Paginator(props: PaginatorProps): React.ReactElement | null {
    const maxElements = props.maxElements ? props.maxElements : 7

    const paginatorOutput = paginator({
        current: props.current,
        last: props.total,
        maxElements: maxElements,
    })

    if (!paginatorOutput) {
        return <p className="active unic-page">1</p>
    }

    const { current, first, last, pages, leftCluster, rightCluster } = paginatorOutput

    const handlePageClick =
        (n: number) =>
            (e: React.SyntheticEvent): void => {
                e.preventDefault()
                props.onClick(n)
            }

    const currentItem = <p className="active">{current}</p>

    const firstPage = (
        <li>
            {current === first ? (
                currentItem
            ) : (
                <p onClick={handlePageClick(1)} className="cursor-pointer">
                    {first}
                </p>
            )}
        </li>
    )

    const lastPage = (
        <li>
            {current === last ? (
                currentItem
            ) : (
                <p onClick={handlePageClick(last)} className="cursor-pointer">
                    {last}
                </p>
            )}
        </li>
    )

    const arrowsVisible = last > maxElements

    return (
        <ul className="paginator">
            {arrowsVisible && (
                <li>
                    {current === 1 ? (
                        <p></p>
                    ) : (
                        <p onClick={handlePageClick(current - 1)} className="cursor-pointer">
                            {'<'}
                        </p>
                    )}
                </li>
            )}
            {firstPage}
            {leftCluster && (
                <li>
                    <p>...</p>
                </li>
            )}
            {pages.map((page: number) => (
                <li key={page}>
                    {page === current ? (
                        currentItem
                    ) : (
                        <p onClick={handlePageClick(page)} className="cursor-pointer">
                            {page}
                        </p>
                    )}
                </li>
            ))}
            {rightCluster && (
                <li>
                    <p>...</p>
                </li>
            )}
            {lastPage}
            {arrowsVisible && (
                <li>
                    {current === props.total ? (
                        <p></p>
                    ) : (
                        <p onClick={handlePageClick(current + 1)} className="cursor-pointer">
                            {'>'}
                        </p>
                    )}
                </li>
            )}
        </ul>
    )
}
